'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgArrowLeft = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { d: "M8.62 4.046c-.245.126-7.464 7.351-7.583 7.589-.12.24-.12.49 0 .73.129.258 7.342 7.467 7.6 7.596.353.176.718.087 1.064-.26.347-.347.436-.711.26-1.064-.063-.124-.903-.993-2.814-2.907L4.421 13h8.4c5.503 0 8.449-.014 8.544-.041a.842.842 0 0 0 .515-.401c.087-.156.1-.226.099-.558-.001-.433-.081-.645-.301-.801-.292-.209.133-.199-8.874-.199H4.421l2.726-2.73c1.911-1.914 2.751-2.783 2.814-2.907.176-.353.087-.717-.26-1.064-.34-.34-.733-.432-1.081-.253", fillRule: "evenodd", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgArrowLeft);

exports["default"] = ForwardRef;
//# sourceMappingURL=ArrowLeft.js.map
